import React, { Component } from 'react';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import {
  Row,
  FormGroup,
  Col,
  FormControl,
  Form,
  Container,
  InputGroup,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import Switch from 'react-switch';

import Loader from '../../Common/Loader/Loader';
import ToneDropzone from './ToneDropzone';
import { checkedIcon, uncheckedIcon } from '../../SiteAdmin/SiteSettingsForm/Switch';

import s from './MobileSettingsForm.css';
import { siteSettings } from '../../../actions/siteadmin/SiteSettings/siteSettings';
import { deleteTone } from '../../../actions/siteadmin/SiteSettings/updateMobileSettings';

import pauseIcon from '../../../../public/Icons/tonePause.svg';
import playIcon from '../../../../public/Icons/tonePlay.svg';
import deleteIcon from '../../../../public/Icons/toneClose.svg';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';
import { api, toneUploadDir } from '../../../config';

export class MobileSettingsForm extends Component {

  static defaultProps = {
    loading: false,
    updateSettings: false
  };

  constructor(props) {
    super(props);
    this.state = {
      play: false
    }
    this.togglePlay = this.togglePlay.bind(this);
  }

  togglePlay = () => {
    const audioEl = document.getElementById("audio-element");
    if (audioEl) {
      this.setState({ play: !this.state.play }, () => {
        this.state.play ? audioEl.play() : audioEl.pause();
      });
    }
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={'positionRelative'}>
        <FormGroup className={s.space2}>
          <label className={'inputLabel'}>{label}</label>
          <FormControl {...input} placeholder={label} type={type} className={cx(className, s.formControlInput)} maxLength={maxlength} />
          {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
        </FormGroup>
      </div>
    );
  }

  renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children }) => {
    return (
      <Form.Group className={cx(s.space2, 'positionRelative')}>
        <Form.Label className={'inputLabel'}>{label}</Form.Label>
        <Form.Control as="select" {...input} placeholder={placeholder} className={fieldClass}>
          {children}
        </Form.Control>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{error.defaultMessage}</span>}
      </Form.Group>
    )
  }

  renderFieldApp = ({ input, label, type, meta: { touched, error }, className, maxlength, suffix, addonLabel }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('inputFormAddon', 'addonBorder')}>
        <Form.Group className={'positionRelative'}>
          {!suffix && <label className={cx('inputLabel', 'accordionLabel')}>{label}</label>}
          {suffix && <label className={cx('inputLabel')}>{label}</label>}
          <InputGroup>
            {!suffix && <InputGroup.Append>
              <InputGroup.Text>
                V
              </InputGroup.Text>
            </InputGroup.Append>}
            <FormControl {...input} placeholder={label} type={type} className={cx(s.formControlInput, suffix && 'inputLeft')} maxLength={maxlength} />
            {suffix && <InputGroup.Append className={'rightAddonBtn'}>
              <InputGroup.Text>
                {addonLabel || formatMessage(messages.seconds)}
              </InputGroup.Text>
            </InputGroup.Append>}
          </InputGroup>
          {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{error.defaultMessage}</span>}
        </Form.Group>
      </div>
    )
  }

  renderSwitch = ({ input, label, trueValue = '1', falseValue = '0', tooltip }) => {
    const checked = input.value == trueValue;
    return (
      <Form.Group className={s.space2}>
        <label className={cx(s.switchLabel, tooltip && s.labelWithInfo)}>
          {label}
          {tooltip && (
            <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <span className={s.infoIcon}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </OverlayTrigger>
          )}
        </label>
        <div className={s.switchWrapper}>
          <Switch
            checked={checked}
            onChange={(val) => input.onChange(val ? trueValue : falseValue)}
            offColor='#dce0e0'
            onColor='#E62529'
            handleDiameter={30}
            checkedIcon={checkedIcon}
            uncheckedIcon={uncheckedIcon}
            height={34}
            width={58}
            boxShadow='none'
            activeBoxShadow='0px 0px 2px 3px #E62529'
          />
        </div>
      </Form.Group>
    )
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit, submitting, updateSettings, appForceUpdate, requestTone, deleteTone, requestToneFile } = this.props;
    const { data: { getCurrencies } } = this.props;

    return (
      <div className={s.paddignLeftRight}>
        <Container fluid>
          <form onSubmit={handleSubmit(submit)}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>

                {/* Section 1: General Settings */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.generalSettingsSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field
                      name="distanceUnits"
                      placeholder={formatMessage(messages.distanceUnits)}
                      component={this.renderSelectField}
                      label={formatMessage(messages.distanceUnits)}
                      labelClass={s.labelText}
                      fieldClass={cx(s.formControlSelect, s.formControlInput)}
                    >
                      <option value="km">{formatMessage(messages.kmLabel)}</option>
                      <option value="miles">{formatMessage(messages.milesLabel)}</option>
                    </Field>
                    <Field
                      name="currency"
                      placeholder={formatMessage(messages.currency)}
                      component={this.renderSelectField}
                      label={formatMessage(messages.currency)}
                      labelClass={s.labelText}
                      fieldClass={cx(s.formControlSelect, s.formControlInput)}
                    >
                      <option value={""}>{formatMessage(messages.currency)}</option>
                      {getCurrencies && getCurrencies.map((item, index) => (
                        item.isEnable == 1 && <option key={index} value={item.symbol}>{item.symbol}</option>
                      ))}
                    </Field>
                    <Field name="modifiers" component={this.renderSwitch} label={formatMessage(messages.enableModifiers)} trueValue="1" falseValue="0" tooltip={formatMessage(messages.enableModifiersTooltip)} />
                    <Field name="maxUploadSize" type="text" component={this.renderFormControl} label={formatMessage(messages.maxUploadLabel)} />
                  </div>
                </div>

                {/* Section 2: Delivery Settings */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.deliverySettingsSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Form.Group className={s.space2}>
                      <div className={'positionRelative'}>
                        <label className={'inputLabel'}>{formatMessage(messages.preferredDelivery)}</label>
                        <Field name="preferredDelivery" className={cx(s.formControlSelect, s.formControlInput)} component="select">
                          <option value="1">{formatMessage(messages.meetAtDoor)}</option>
                          <option value="2">{formatMessage(messages.leaveAtDoor)}</option>
                          <option value="3">{formatMessage(messages.pickUpOutside)}</option>
                        </Field>
                      </div>
                    </Form.Group>
                    <Field name="orderAcceptInterval" type="text" component={this.renderFieldApp} label={formatMessage(messages.orderAcceptInterval)} suffix={true} maxLength={3} />
                    <Field name="notificationInterval" type="text" component={this.renderFieldApp} label={formatMessage(messages.notificationInterval)} suffix={true} addonLabel={formatMessage(messages.minutes)} maxLength={10} />
                    <Field name="subtractTime" type="text" component={this.renderFieldApp} label={formatMessage(messages.subtractTime)} suffix={true} addonLabel={formatMessage(messages.minutes)} maxLength={10} />
                    <Field name="maxDistance" type="text" component={this.renderFieldApp} label={formatMessage(messages.distance)} suffix={true} addonLabel={formatMessage(messages.kmLabel)} maxLength={10} />
                    <Field name="maxSearchDuration" type="text" component={this.renderFieldApp} label={formatMessage(messages.maxSearchDuration)} suffix={true} addonLabel={formatMessage(messages.minutes)} maxLength={10} />
                    <Field name="retryInterval" type="text" component={this.renderFieldApp} label={formatMessage(messages.retryInterval)} suffix={true} addonLabel={formatMessage(messages.seconds)} maxLength={10} />
                    <Field name="maxWeight" type="text" component={this.renderFieldApp} label={formatMessage(messages.maxWeightLabel)} suffix={true} addonLabel="gram" maxLength={10} />
                  </div>
                </div>

                {/* Section 3: App Update Settings */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.appUpdateSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field name="appForceUpdate" component={this.renderSwitch} label={formatMessage(messages.forceUpdate)} trueValue="true" falseValue="false" />
                    {appForceUpdate === 'true' && <>
                      <div className={s.versionGroup}>
                        <div className={s.versionGroupLabel}>{formatMessage(messages.userApp)}</div>
                        <Field name="userAndroidVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.userAndriodVersion)} maxLength={10} />
                        <Field name="userIosVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.useriosVersion)} maxLength={10} />
                      </div>
                      <div className={s.versionGroup}>
                        <div className={s.versionGroupLabel}>{formatMessage(messages.driverApp)}</div>
                        <Field name="driverAndroidVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.driverAndriodVersion)} maxLength={10} />
                        <Field name="driverIosVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.driveriosVersion)} maxLength={10} />
                      </div>
                    </>}
                  </div>
                </div>

                {/* Section 4: Driver App */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.driverAppSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field name="openAppOnRequest" component={this.renderSwitch} label={formatMessage(messages.appOpenRequest)} trueValue="1" falseValue="0" />
                    <Field name="isRequestTimerToneEnable" component={this.renderSwitch} label={formatMessage(messages.requestTone)} trueValue="1" falseValue="0" />
                    <Form.Group className={s.formGroup}>
                      <div className={'positionRelative'}>
                        <label className={'inputLabel'}>{formatMessage(messages.uploadRequestTone)}</label>
                        {!requestTone && <div className={cx('commonFilepicker', 'tonePicker')}>
                          <ToneDropzone
                            className={cx(s.btnSecondary, 'fileNoPadding')}
                            subTextClass={s.subText}
                            subText={formatMessage(messages.maximumUploadSizeLabel)}
                            defaultMessage={formatMessage(messages.chooseFile)}
                          />
                        </div>}
                        {requestTone && <div className={s.audioSection}>
                          <div>{requestToneFile}</div>
                          <div className={s.flex}>
                            <div>
                              <span onClick={this.togglePlay}>{this.state.play ? <img src={pauseIcon} className={s.imgWidth} /> : <img src={playIcon} className={s.imgWidth} />}</span>
                            </div>
                            <div className={cx(s.paddingLeft, 'toneCloseRTL')}>
                              <span onClick={() => deleteTone(requestTone)}><img src={deleteIcon} className={s.imgWidth} /></span>
                            </div>
                          </div>
                          <audio id="audio-element">
                            <source src={api.apiEndpoint + toneUploadDir + requestTone}></source>
                          </audio>
                        </div>}
                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className={cx(s.textAlignRight, 'textAlignLeftRTL')}>
                  <FormGroup className={s.space3}>
                    <div>
                      <Loader
                        type={"button"}
                        label={formatMessage(messages.submitButton)}
                        show={updateSettings || submitting}
                        buttonType={'submit'}
                        className={cx(s.button, s.btnPrimary)}
                        disabled={updateSettings || submitting}
                        isSuffix={true}
                      />
                    </div>
                  </FormGroup>
                </div>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    )
  }
}

const callSiteSettings = async (result, dispatch, props) => {
  const { refetch } = props
  await refetch()
  dispatch(siteSettings())
}

MobileSettingsForm = reduxForm({
  form: 'MobileSettingsForm',
  onSubmit: submit,
  validate,
  onSubmitSuccess: callSiteSettings
})(MobileSettingsForm);

const selector = formValueSelector('MobileSettingsForm')
const mapState = (state) => ({
  appForceUpdate: selector(state, 'appForceUpdate'),
  updateSettings: state.siteSettings.updateSettings,
  loading: state.loader.MobileSettings,
  requestTone: selector(state, 'requestTimeTone'),
  requestToneFile: selector(state, 'requestToneFile'),
})

const mapDispatch = {
  siteSettings,
  deleteTone

}

export default injectIntl(
  compose(
    withStyles(s),
    connect(mapState, mapDispatch),
    graphql(gql`query {
      getCurrencies {
        id
        symbol
        isEnable
      }
    }`, {
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    })
  )(MobileSettingsForm));